<template>
  <section class="page-shell about-page">
    <article>
      <button class="legal-back" @click="navigate('home')">← Back to CalmDecide</button>
      <span class="eyebrow"><span></span>About</span>
      <h1>A quieter way to make decisions.</h1>
      <p class="article-intro">CalmDecide is an independent decision companion built around a simple belief: people rarely need more noise when they are stuck. They need a smaller next step, a clearer frame, and sometimes a gentle nudge.</p>

      <h2>What CalmDecide offers</h2>
      <p>For everyday choices, CalmDecide uses lightweight tools such as a wheel, coin flip, and curated prompts to end low-stakes loops quickly. For important choices, it offers a weighted decision matrix and reflection questions so users can see tradeoffs instead of carrying them vaguely in their head.</p>
      <p>The site also includes original editorial guides about decision fatigue, regret, outside advice, and practical frameworks. These guides are written for readers who want to understand the method, not just press a button.</p>

      <h2>Our editorial approach</h2>
      <p>CalmDecide content is written in plain English, reviewed for usefulness, and focused on practical judgment. We avoid pretending that a tool can know a person’s life better than they do. The goal is to support clarity, not replace responsibility.</p>

      <h2>Important limitations</h2>
      <p>CalmDecide does not provide medical, legal, financial, crisis, or professional advice. High-stakes decisions should include qualified help where appropriate. The site is best used as a thinking aid: a way to organize options, reveal preferences, and move from anxious loops toward considered action.</p>

      <h2>Contact</h2>
      <p>Questions, corrections, feedback, and policy requests can be sent to <a href="mailto:tudouchenxiaoze@gmail.com">tudouchenxiaoze@gmail.com</a>.</p>
    </article>
  </section>
</template>

<script>
export default {
  name: 'AboutView',
  inject: ['navigate']
}
</script>
